var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 18,
      height: 18
    },
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 2h19.477v19.477H2.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#632E8F",
    d: "M12.239 3.5c-4.543 0-8.24 3.695-8.24 8.238s3.697 8.24 8.24 8.24c4.542 0 8.238-3.697 8.238-8.24S16.78 3.5 12.239 3.5m0 17.977c-5.37 0-9.74-4.369-9.74-9.739S6.87 2 12.24 2s9.738 4.368 9.738 9.738-4.368 9.74-9.738 9.74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "search_svg__b",
    width: 6,
    height: 6,
    x: 17,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.74 17.707h5.024v5.015H17.74z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#search_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#632E8F",
    d: "M22.014 22.722a.75.75 0 0 1-.53-.22L17.96 18.99a.75.75 0 0 1 1.06-1.063l3.524 3.515a.749.749 0 0 1-.53 1.28"
  }))));
};
export default SvgSearch;